var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BN } from "@coral-xyz/anchor";
import { createAssociatedTokenAccountInstruction } from "@solana/spl-token";
import { PublicKey, Transaction } from "@solana/web3.js";
import { getProgram } from "../utils/getProgram.obj";
import { decode } from "bs58";
import { getProofMeta } from "../utils/getCNFTData.function";
export var apiProcessorTranscript = function (Data) { return __awaiter(void 0, void 0, void 0, function () {
    var depositTransaction, program, lastWasCreateAccount, _i, _a, item, _b, createAssociatedTokenAccountInstructionix, depositNftIx, depositCNftIx, depositSolIx, txWithoutSigner;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                depositTransaction = [];
                program = getProgram({
                    clusterOrUrl: Data.clusterOrUrl,
                    programId: Data.programId,
                });
                lastWasCreateAccount = false;
                _i = 0, _a = Data.config;
                _c.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 11];
                item = _a[_i];
                _b = item.type;
                switch (_b) {
                    case "createAssociatedTokenAccountInstruction": return [3 /*break*/, 2];
                    case "depositNft": return [3 /*break*/, 3];
                    case "depositCNft": return [3 /*break*/, 5];
                    case "depositSol": return [3 /*break*/, 7];
                }
                return [3 /*break*/, 9];
            case 2:
                createAssociatedTokenAccountInstructionix = createAssociatedTokenAccountInstruction(new PublicKey(item.data.payer), new PublicKey(item.data.associatedToken), new PublicKey(item.data.owner), new PublicKey(item.data.mint));
                console.log("create ATA");
                if (lastWasCreateAccount === true) {
                    console.log("added to previous Tx");
                    depositTransaction[depositTransaction.length - 1].add(createAssociatedTokenAccountInstructionix);
                }
                else {
                    depositTransaction.push(new Transaction().add(createAssociatedTokenAccountInstructionix));
                }
                lastWasCreateAccount = true;
                return [3 /*break*/, 10];
            case 3: return [4 /*yield*/, program.methods
                    .depositNft(Buffer.from(item.data.arguments.SDA_seed))
                    .accounts({
                    systemProgram: new PublicKey(item.data.accounts.systemProgram),
                    metadataProgram: new PublicKey(item.data.accounts.metadataProgram),
                    sysvarInstructions: new PublicKey(item.data.accounts.sysvarInstructions),
                    splTokenProgram: new PublicKey(item.data.accounts.splTokenProgram),
                    splAtaProgram: new PublicKey(item.data.accounts.splAtaProgram),
                    swapDataAccount: new PublicKey(item.data.accounts.swapDataAccount),
                    signer: new PublicKey(item.data.accounts.signer),
                    itemFromDeposit: new PublicKey(item.data.accounts.itemFromDeposit),
                    mint: new PublicKey(item.data.accounts.mint),
                    nftMetadata: new PublicKey(item.data.accounts.nftMetadata),
                    itemToDeposit: new PublicKey(item.data.accounts.itemToDeposit),
                    nftMasterEdition: new PublicKey(item.data.accounts.nftMasterEdition),
                    ownerTokenRecord: new PublicKey(item.data.accounts.ownerTokenRecord),
                    destinationTokenRecord: new PublicKey(item.data.accounts.destinationTokenRecord),
                    authRulesProgram: new PublicKey(item.data.accounts.authRulesProgram),
                    authRules: new PublicKey(item.data.accounts.authRules),
                })
                    .instruction()];
            case 4:
                depositNftIx = _c.sent();
                console.log("deposit Nft");
                if (lastWasCreateAccount === true) {
                    console.log("added to previous Tx");
                    depositTransaction[depositTransaction.length - 1].add(depositNftIx);
                    // depositTransaction.push(new Transaction());
                    lastWasCreateAccount = false;
                }
                else {
                    depositTransaction.push(new Transaction().add(depositNftIx));
                }
                return [3 /*break*/, 10];
            case 5: return [4 /*yield*/, program.methods
                    .depositCNft(Buffer.from(item.data.arguments.seed), decode(item.data.arguments.root), decode(item.data.arguments.dataHash), decode(item.data.arguments.creatorHash), new BN(item.data.arguments.nonce), item.data.arguments.index)
                    .accounts({
                    metadataProgram: item.data.accounts.metadataProgram,
                    sysvarInstructions: item.data.accounts.sysvarInstructions,
                    splTokenProgram: item.data.accounts.splTokenProgram,
                    splAtaProgram: item.data.accounts.splAtaProgram,
                    swapDataAccount: item.data.accounts.swapDataAccount,
                    user: item.data.accounts.user,
                    leafDelegate: item.data.accounts.leafDelegate,
                    treeAuthority: item.data.accounts.treeAuthority,
                    merkleTree: item.data.accounts.merkleTree,
                    logWrapper: item.data.accounts.logWrapper,
                    compressionProgram: item.data.accounts.compressionProgram,
                    bubblegumProgram: item.data.accounts.bubblegumProgram,
                })
                    .remainingAccounts(getProofMeta(item.data.remainingAccounts))
                    .instruction()];
            case 6:
                depositCNftIx = _c.sent();
                console.log("deposit CNft");
                depositTransaction.push(new Transaction().add(depositCNftIx));
                return [3 /*break*/, 10];
            case 7: return [4 /*yield*/, program.methods
                    .depositSol(Buffer.from(item.data.arguments.SDA_seed))
                    .accounts({
                    systemProgram: new PublicKey(item.data.accounts.systemProgram),
                    splTokenProgram: new PublicKey(item.data.accounts.splTokenProgram),
                    swapDataAccount: new PublicKey(item.data.accounts.swapDataAccount),
                    swapDataAccountAta: new PublicKey(item.data.accounts.swapDataAccountAta),
                    signer: new PublicKey(item.data.accounts.signer),
                    signerAta: new PublicKey(item.data.accounts.signerAta),
                })
                    .instruction()];
            case 8:
                depositSolIx = _c.sent();
                console.log("deposit Sol");
                if (lastWasCreateAccount === true) {
                    console.log("added to previous Tx");
                    depositTransaction[depositTransaction.length - 1].add(depositSolIx);
                    // depositTransaction.push(new Transaction());
                    lastWasCreateAccount = false;
                }
                else {
                    depositTransaction.push(new Transaction().add(depositSolIx));
                }
                lastWasCreateAccount = false;
                return [3 /*break*/, 10];
            case 9: throw { message: "function not found" };
            case 10:
                _i++;
                return [3 /*break*/, 1];
            case 11:
                txWithoutSigner = [];
                depositTransaction.map(function (tx) { return txWithoutSigner.push({ tx: tx }); });
                return [2 /*return*/, txWithoutSigner];
        }
    });
}); };
// export default apiProcessorTranscript;
